// import React from 'react'
import { axiosInstance } from './axiosSetup';
import { costOfCracker } from './CrackersUtil';

export const userLogin = async (mobileNumber, password, loadingSetter) => {
    if(loadingSetter) {
        loadingSetter(true);
    }
    const data = new URLSearchParams({
        "username": mobileNumber,
        "password": password
    });
    const response = await fetch(`/v1/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: data
    });
    const result = await response.json();
    if(loadingSetter) {
        loadingSetter(false);
    }
    return result;
};

export const raiseGetRequest = async (uri, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if(loadingSetter) {
        loadingSetter(true);
    }
    const response = await axiosInstance.get(uri);
    if (loadingSetter) {
        loadingSetter(false);
    }
    if(response) {
        const status = response.status;
        var data = null;
        if (status < 300) {
            data = response.data;
        } else {
            var toastType, toastTitle;
            if (status < 500) {
                toastType = 'warning';
                toastTitle = "Client Error - " + response.data.error_code;
            } else {
                toastType = 'danger';
                toastTitle = "Server Error - " + response.data.error_code;
            }
            if (setShowErrorToastStatus) {
                setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": response.data.error_message });
                setShowErrorToastStatus(true);
            }
            data = response.data;
        }
        if (data) {
            return data;
        }   
    } else {
        return null;
    }
}

export const getCracker = async (userInfo, cracker_id, selected_cart, setLoading, setShowErrorToastStatus, setToastBody, browserCart) => {
    var response,  linkToDetailView;
    if(userInfo && userInfo.authenticated) {
        linkToDetailView = `/crackers/${cracker_id}?cart=${selected_cart}`;
    } else {
        linkToDetailView = `/crackers/${cracker_id}`;
    }
    response = await raiseGetRequest(linkToDetailView, null, setLoading, setShowErrorToastStatus, setToastBody)
    if(userInfo === undefined || userInfo === null || !userInfo.authenticated) { 
        var cartItems = JSON.parse(browserCart);
        if(cartItems.length > 0) {
            const item = cartItems.find(item => item.cracker_id === Number(cracker_id));
            response.quantity = item ? item.quantity : 0;
        }
    }
    return response;
}

export const addCrackersIntoCart = async (userInfo, cracker_id, params, setLoading, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart) => {
    let response;
    if (userInfo && userInfo.authenticated) {
        response = await raisePostRequest(`/crackers/${cracker_id}/add-cart`, params, setLoading, setShowErrorToastStatus, setToastBody);
    } else {
        // setBrowserCart(JSON.stringify([]));
        let cartItems = JSON.parse(browserCart);
        const itemIndex = cartItems.findIndex(item => item.cracker_id === cracker_id);
        if (itemIndex !== -1) {
            cartItems[itemIndex] = { ...cartItems[itemIndex], quantity: params.quantity };
        } else {
            cartItems.push({ cracker_id, quantity: params.quantity });
        }
        setBrowserCart(JSON.stringify(cartItems));
        response = { "status": "success" };
    }
    return response;
};

export const addBrowserCartItems = async (agentId, browserCart, setBrowserCart) => {
    const response = await raisePostRequest(`/carts/Default/items`, {"agent_id" : agentId, "crackers" : browserCart}, null, null, null);
    setBrowserCart(JSON.stringify([]));
    return response;
}

export const removeCrackersFromCart = async (userInfo, cartName, crackersId, browserCart, setBrowserCart, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if (userInfo && userInfo.authenticated) {
        const response = await raiseDeleteRequest(`/carts/${cartName}/items/${crackersId}`, null, null, null, null);
        return response;
    } else {
        var crackers = JSON.parse(browserCart);
        if(crackers.length > 0) {
            for(let i=0; i<crackers.length; i++) {
                if(crackers[i].cracker_id === crackersId) {
                    crackers[i].quantity = 0;
                    setBrowserCart(JSON.stringify(crackers));
                    return {"status" : "success"};
                }
            }
        }
    }
}

export const clearCartItemsUtil = async (userInfo, payloadData, setBrowserCart, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if (userInfo && userInfo.authenticated) {
        const response = await raiseDeleteRequest(`/carts/items`, payloadData, loadingSetter, setShowErrorToastStatus, setToastBody);
        return response;
    } else {
        setBrowserCart(JSON.stringify([]));
        return {"status" : "success"};
    }
    
}

export const getCarts = async (userInfo, setShowErrorToastStatus, setToastBody, browserCart) => {
    if(userInfo && userInfo.authenticated) {
        const response = await raiseGetRequest(`/carts`, null, setShowErrorToastStatus, setToastBody);
        if(response && response.status && response.status === 'failure') {
            return JSON.parse(`[{"cart_id": -1,"customer_id": -1,"name": "Default","number_of_items": -1}]`);
        }
        return response
    } else {
        return JSON.parse(`[{"cart_id": -1,"customer_id": -1,"name": "Default","number_of_items": ${getBrowserCartsItemsCount(JSON.parse(browserCart))}}]`);
    }
}

const getBrowserCartsItemsCount = (cartItems) => {
    var numberOfItems = 0;
    for(let i=0; i<cartItems.length; i++) {
        if(cartItems[i].quantity > 0) {
            numberOfItems++;
        }
    }
    return numberOfItems;
}

export const getCartItems = async (userInfo, crackersList, selectedCart, agentCode, setShowErrorToastStatus, setToastBody, browserCart) => {
    if(userInfo && userInfo.authenticated) {
        const cartItemsResp = await raiseGetRequest(`/carts/${selectedCart}/items?agent_id=${agentCode}`, null, setShowErrorToastStatus, setToastBody);
        return cartItemsResp;
    } else {
        var cartItems = JSON.parse(browserCart);
        if(cartItems.length > 0) {
            for(let i=0; i<cartItems.length; i++) {
                if(cartItems[i].quantity > 0) {
                    const price = costOfCracker(crackersList, cartItems[i].cracker_id);
                    if(price > 0) {
                        cartItems[i].total_cost = cartItems[i].quantity * price;
                    } else {
                        cartItems[i].total_cost = 0;
                    }
                } else {
                    cartItems[i].total_cost = 0
                }
            }
        }
        return cartItems;
    }  
}

export const getCartViewItems = async (userInfo, browserCart, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    var response;
    if(userInfo && userInfo.authenticated) {
        response = await raisePostRequest(`/carts/carts-view-data`, null, loadingSetter, setShowErrorToastStatus, setToastBody);
        return response;
    } else {
        var cartItems = JSON.parse(browserCart);
        var data = {"cart_name" : "Default", "data" : [{"agent_name" : "TVK", "crackers" : []}]};
        if(cartItems.length > 0) {
            response = await raisePostRequest('/carts/un-auth/carts-view-data', {"browser_cart" : browserCart, "response_as" : "json"}, loadingSetter, setShowErrorToastStatus, setToastBody);
            var crackers = [];
            for(let i=0; i<cartItems.length; i++) {
                let crackersID = cartItems[i].cracker_id;
                let quantity = cartItems[i].quantity;
                let cracker = response[crackersID + ""];
                if(quantity > 0) {
                    cracker.order_quantity = quantity;
                    cracker.order_price = cracker.offer_price * quantity;
                    crackers.push(cracker);
                }
            }
            data["data"][0]["crackers"] = crackers;
        }
        return [data];
    }
}

export const getCartsValue = async (userInfo, cartsItems, defaultAgentId, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    var response;
    if(userInfo && userInfo.authenticated) {
        response = await raisePostRequest(`/carts/carts-tot-amount`, null, loadingSetter, setShowErrorToastStatus, setToastBody);
    } else {
        response = [];
        var crackers = cartsItems[0]["data"][0]["crackers"];
        var cartValue = 0, totalQuantity = 0;
        if(crackers.length > 0) {
            for(let i=0; i<crackers.length; i++) {
                cartValue += crackers[i].order_price;
                totalQuantity += crackers[i].order_quantity;
            }
            response.push({"agent_id" : defaultAgentId, "agent_name" : "TVK", "min_order" : 2500, "cart_value" : cartValue, "quantity" : totalQuantity });
        } else {
            response.push({"agent_id" : defaultAgentId, "agent_name" : "TVK", "min_order" : 2500, "cart_value" : 0, "quantity" : 0 });
        }
    }
    return response;
}

export const raisePostRequest = async (uri, payloads, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if(loadingSetter) {
        loadingSetter(true);
    }
    const formData = new URLSearchParams();
    if(payloads && Object.keys(payloads).length != 0) {
        for (const key in payloads) {
            formData.append(key, payloads[key]);
        }    
    }
    const response = await axiosInstance.post(uri, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    if(loadingSetter) {
        loadingSetter(false);
    }
    if(response) {
        const status = response.status;
        var data = null;
        if (status < 300) {
            data = response.data;
        } else {
            var toastType, toastTitle;
            if (status < 500) {
                toastType = 'warning';
                toastTitle = "Client Error - " + response.data.error_code;
            } else {
                toastType = 'danger';
                toastTitle = "Server Error - " + response.data.error_code;
            }
            if (setShowErrorToastStatus) {
                setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": response.data.error_message });
                setShowErrorToastStatus(true);
            }
            data = response.data;
        }
        if (data) {
            return data;
        }
    } else {
        return null;
    }
};

export const raisePutRequest = async (uri, payloads, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if(loadingSetter) {
        loadingSetter(true);
    }
    const formData = new URLSearchParams();
    if(payloads && Object.keys(payloads).length != 0) {
        for (const key in payloads) {
            formData.append(key, payloads[key]);
        }    
    }
    const response = await axiosInstance.put(uri, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    if(loadingSetter) {
        loadingSetter(false);
    }
    if(response) {
        const status = response.status;
        var data = null;
        if (status < 300) {
            data = response.data;
        } else {
            var toastType, toastTitle;
            if (status < 500) {
                toastType = 'warning';
                toastTitle = "Client Error - " + response.data.error_code;
            } else {
                toastType = 'danger';
                toastTitle = "Server Error - " + response.data.error_code;
            }
            if (setShowErrorToastStatus) {
                setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": response.data.error_message });
                setShowErrorToastStatus(true);
            }
            data = response.data;
        }
        if (data) {
            return data;
        }
    } else {
        return null;
    }
};

export const raiseDeleteRequest = async (uri, payloads, loadingSetter, setShowErrorToastStatus, setToastBody) => {
    if(loadingSetter) {
        loadingSetter(true);
    }

    const formData = new URLSearchParams();
    if(payloads && Object.keys(payloads).length != 0) {
        for (const key in payloads) {
            formData.append(key, payloads[key]);
        }
    }
    const response = await axiosInstance.delete(uri, 
                        {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            data : payloads
                        });
    if(loadingSetter) {
        loadingSetter(false);
    }
    if(response) {
        const status = response.status;
        var data = null;
        if (status < 300) {
            data = response.data;
        } else {
            var toastType, toastTitle;
            if (status < 500) {
                toastType = 'warning';
                toastTitle = "Client Error - " + response.data.error_code;
            } else {
                toastType = 'danger';
                toastTitle = "Server Error - " + response.data.error_code;
            }
            if (setShowErrorToastStatus) {
                setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": response.data.error_message });
                setShowErrorToastStatus(true);
            }
            data = response.data;
        }
        if (data) {
            return data;
        }
    } else {
        return null;
    }
};